export class ImageInfo {
    constructor(
        public url: string,
        public largeUrl: string,
        public smallUrl: string,
        public title: string,
        public size: string,
        public material: string,
        public sale: string
        ) {
    }
}
